<template>
  <div>
     <el-dialog
     title="历史记录"
     width="60%"
     class="imgbox"
     :append-to-body="true"
     :visible.sync="dialogFlag"
     :before-close="resetForm"
     :close-on-click-modal='false'>
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="vendorId"
            label="所属厂家">
          </el-table-column>
          <el-table-column
            prop="snCount"
            label="sn数量">
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <a :href="scope.row.fileUrl">下载</a>
            </template>
          </el-table-column>
        </el-table>
         <!-- 分页管理 -->
      <el-row
        class="pagination-container"
        type="flex" justify="end"
        >
        <!-- 页码按钮的数量currenCurrent  sizeChange -->
        <el-pagination
          :current-page.sync="listQuery.page"
          :page-sizes="[5,15,20,30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"/>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { snFileList } from '@/api/productControl'
export default {
  props: {
    dialogFlag: {
      type: Boolean
    }
  },
  data () {
    return {
      tableData: [],
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      }
    }
  },
  created () {
    this.getHistoryList()
  },
  methods: {
    getHistoryList () {
      const params = {
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      snFileList(params).then((res) => {
        const result = res.data.data
        this.tableData = result.SysVendorSnFileList
        this.total = result.total
      })
    },
    // 分页管理
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getHistoryList()
    },
    // 改变页码
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getHistoryList()
    },
    resetForm () {
      this.$emit('closeHistoryDialog')
    }
  }
}
</script>

<style lang='less' scoped>

</style>
